import { ButtonError } from '@flatsy/core/MaterialUi/Button'
import i18n from '@flatsy/utils/translations'
import { AppBar, Box, LinkProps, Toolbar, Link as UILink } from '@material-ui/core'
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined'
import EventIcon from '@material-ui/icons/Event'
import clsx from 'clsx'
import React from 'react'
import { NavLink, generatePath } from 'react-router-dom'
import * as ROUTES from 'src/constants/Routes'
import { useApplicationDetails } from 'src/hooks/ApplicationDetails'
import { useMobile } from 'src/hooks/Mobile'
import { LogoAgency } from 'src/utils/LogoAgency'
import { useStyle } from './Styles'
import { NavigationProps } from './Type'

const NavigationLink: React.FC<LinkProps<NavLink>> = (props) => {
  const classes = useStyle()
  const { className } = props

  return (
    <UILink
      component={NavLink}
      activeClassName={classes.navLinkActive}
      {...props}
      className={clsx(classes.navLink, className)}
      underline="none"
      variant="body1"
      color="textPrimary"
    />
  )
}

const Navigation: React.FC<NavigationProps> = ({
  asset,
  applicationId,
  qualification,
}): React.ReactElement => {
  const classes = useStyle()
  const isMobile = useMobile()
  const {
    application: { application },
  } = useApplicationDetails()

  if (isMobile) {
    return (
      <AppBar position="fixed" color="primary" className={classes.bottomNavigation}>
        <NavigationLink
          to={{
            pathname: generatePath(ROUTES.APPLICATION_BOOKING, {
              applicationId,
            }),
          }}
          className="booking"
        >
          <EventIcon className={classes.navigationIcon} />
          <span className={classes.navigationLabel}>{i18n.t('visit')}</span>
        </NavigationLink>
        {!asset?.is_sale &&
          qualification?.need_uploads === true &&
          application.is_verlingue_supported === false && (
            <>
              <div id="add-file-navigation-button" />
              <NavigationLink
                to={{
                  pathname: generatePath(ROUTES.APPLICATION_DOSSIER, {
                    applicationId,
                  }),
                }}
                className="dossier"
              >
                <AccountCircleOutlinedIcon className={classes.navigationIcon} />
                <span className={classes.navigationLabel}>{i18n.t('file')}</span>
              </NavigationLink>
            </>
          )}
      </AppBar>
    )
  }

  return (
    <>
      <Toolbar component="header" disableGutters className={classes.header}>
        <div className={classes.left}>
          {LogoAgency(classes, asset?.logo_url)}
          <Box component="nav" className={classes.nav}>
            <NavigationLink
              to={{
                pathname: generatePath(ROUTES.APPLICATION_BOOKING, {
                  applicationId,
                }),
              }}
            >
              {i18n.t('my_tour')}
            </NavigationLink>
            <div id="add-file-navigation-button" />
            {!asset?.is_sale &&
              qualification?.need_uploads === true &&
              application.is_verlingue_supported === false && (
                <NavigationLink
                  to={{
                    pathname: generatePath(ROUTES.APPLICATION_DOSSIER, {
                      applicationId,
                    }),
                  }}
                >
                  {i18n.t('my_file')}
                </NavigationLink>
              )}
          </Box>
        </div>
        <NavigationLink
          className={classes.cancelButton}
          to={{
            pathname: generatePath(ROUTES.APPLICATION_DOSSIER_CANCEL, {
              applicationId,
            }),
          }}
        >
          <ButtonError>{i18n.t('cancel_my_application')}</ButtonError>
        </NavigationLink>
      </Toolbar>
    </>
  )
}

export default Navigation
